/**
 * CenteredLoader — a vertically & horizontally centred spinner used as
 * a loading placeholder within the Bulk Add Course Section modal.
 *
 * Shown while CDG header metadata is loading (filter panel area) and
 * while the section list CDG query is in flight (table area).  The
 * configurable `minHeight` ensures the spinner occupies roughly the
 * same space as the content it replaces, preventing layout jumps when
 * data arrives.
 */
import React from 'react'
import { Box, CircularProgress, Fade } from '@mui/material'

interface CenteredLoaderProps {
  minHeight?: number | string
}

const CenteredLoader: React.FC<CenteredLoaderProps> = ({ minHeight = 200 }) => {
  return (
    <Fade in timeout={300}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          minHeight: typeof minHeight === 'number' ? `${minHeight}px` : minHeight,
          py: 4
        }}
      >
        <CircularProgress color="primary" size={40} />
      </Box>
    </Fade>
  )
}

export default CenteredLoader
